import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Navbar,
  Nav,
  Modal,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Picture1 from "./assets/Picture1.svg";
import Picture2 from "./assets/Picture2.svg";
import Picture3 from "./assets/Picture3.svg";
import Picture4 from "./assets/Picture10.svg";
import Picture5 from "./assets/Picture12.svg";
import Picture6 from "./assets/Picture6.svg";
import Picture7 from "./assets/Picture7.svg";
import Picture8 from "./assets/Picture8.svg";
import Picture9 from "./assets/Picture9.svg";
import Picture12 from "./assets/Picture4.svg";
import emailjs from "emailjs-com";

function BlacksmithLandingPage() {
  const [showModal, setShowModal] = useState(false);
  const formRef = useRef();

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_a84n5kn", // e.g. 'service_123abc'
        "template_ja24hid", // e.g. 'template_xyz789'
        formRef.current,
        "slIUFy0DUKjhgDFgd" // e.g. 'user_AbCdEfG'
      )
      .then(
        () => {
          setShowModal(true);
          e.target.reset();
        },
        (error) => {
          console.error("❌ Email failed:", error.text);
          alert("There was an error sending your message.");
        }
      );
  };

  const handleClose = () => setShowModal(false);

  return (
    <div
      style={{
        backgroundColor: "#111",
        color: "#fff",
        fontFamily: "Playfair Display, serif",
      }}
    >
      {/* Navbar */}
      <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
        <Container>
          <Navbar.Brand
            href="#hero"
            style={{ color: "rgba(211, 186, 104, 1)" }}
          >
            <img
              src="/logo1.png"
              alt="The Blacksmith Logo"
              height="40"
              className="d-inline-block align-top"
              style={{ marginRight: "10px" }}
            />
            The Blacksmith
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#services">Services</Nav.Link>
              <Nav.Link href="#edge">Our Edge</Nav.Link>
              <Nav.Link href="#legacy">Legacy</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <section
        id="hero"
        className="text-center py-5"
        style={{ backgroundColor: "#000", marginTop: "56px" }}
      >
        <img
          src="/logo.png"
          alt="The Blacksmith Logo"
          className="img-fluid"
          style={{ maxHeight: "500px" }}
        />
      </section>

      {/* About Us */}
      <Container
        id="about"
        className="py-5 mt-4 mb-4 align-content-center"
        style={{ minHeight: "50vh" }}
        data-aos="fade-up"
      >
        <Row>
          <Col
            md={4}
            className="text-warning pb-5 align-content-center text-center"
          >
            <img
              src={Picture1}
              alt="Section Icon"
              style={{ height: "48px", marginBottom: "10px" }}
            />
            <h3 style={{ color: "rgba(211, 186, 104, 1)" }}>About Us</h3>
          </Col>
          <Col md={8}>
            <div className="d-flex align-items-start mb-3">
              <img
                src={Picture2}
                alt="Icon 2"
                style={{ width: "32px", marginRight: "10px", marginTop: "2px" }}
              />
              <p>
                The Blacksmith is an elite strategic communications firm
                operating at the intersection of diplomacy, policy, and
                influence.
              </p>
            </div>
            <div className="d-flex align-items-start">
              <img
                src={Picture3}
                alt="Icon 3"
                style={{ width: "32px", marginRight: "10px", marginTop: "5px" }}
              />
              <p>
                Rooted in a four-decade media legacy, we architect narratives
                that mobilize, protect, and elevate reputations across global
                arenas.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Our Edge */}
      <Container
        id="edge"
        className="py-5 mt-4 mb-4 align-content-center bg-dark"
        style={{ minHeight: "50vh" }}
        data-aos="fade-up"
      >
        <Row>
          <Col
            md={4}
            className="text-warning pb-5 align-content-center text-center"
          >
            <img
              src={Picture1}
              alt="Section Icon"
              style={{ height: "48px", marginBottom: "10px" }}
            />

            <h3 style={{ color: "rgba(211, 186, 104, 1)" }}>Our Edge</h3>
          </Col>
          <Col md={8}>
            <ul className="list-unstyled">
              <li className="d-flex align-items-start mb-3">
                <img
                  src={Picture12}
                  alt="Edge Icon 1"
                  style={{
                    width: "28px",
                    marginRight: "12px",
                    marginTop: "0px",
                  }}
                />
                <span>Strategic Advisory</span>
              </li>
              <li className="d-flex align-items-start mb-3">
                <img
                  src={Picture6}
                  alt="Edge Icon 2"
                  style={{
                    width: "28px",
                    marginRight: "12px",
                    marginTop: "0px",
                  }}
                />
                <span>Communications Architecture</span>
              </li>
              <li className="d-flex align-items-start mb-3">
                <img
                  src={Picture7}
                  alt="Edge Icon 3"
                  style={{
                    width: "28px",
                    marginRight: "12px",
                    marginTop: "0px",
                  }}
                />
                <span>Brand Power</span>
              </li>
              <li className="d-flex align-items-start mb-3">
                <img
                  src={Picture8}
                  alt="Edge Icon 4"
                  style={{
                    width: "28px",
                    marginRight: "12px",
                    marginTop: "0px",
                  }}
                />
                <span>
                  Confidential, founder-led engagements with measurable KPIs
                </span>
              </li>
              <li className="d-flex align-items-start">
                <img
                  src={Picture9}
                  alt="Edge Icon 5"
                  style={{
                    width: "28px",
                    marginRight: "12px",
                    marginTop: "0px",
                  }}
                />
                <span>Global availability across time zones</span>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>

      {/* Services */}
      <Container
        id="services"
        className="py-5 mb-4 mt-4 align-content-center text-light"
        style={{ minHeight: "50vh" }}
        data-aos="fade-up"
      >
        <Row>
          <Col
            md={4}
            className="text-warning pb-5 align-content-center text-center"
          >
            <img
              src={Picture1}
              alt="Section Icon"
              style={{ height: "48px", marginBottom: "10px" }}
            />

            <h3 style={{ color: "rgba(211, 186, 104, 1)" }}>Services</h3>
          </Col>
          <Col md={8}>
            <div className="d-flex align-items-start mb-4">
              <img
                src={Picture4}
                alt="Service 1 Icon"
                style={{
                  width: "32px",
                  marginRight: "12px",
                  marginTop: "-1px",
                }}
              />
              <div>
                <h5>Sovereign Impact Advisory</h5>
                <p>
                  For governments and leaders navigating post-crisis recovery,
                  nation branding, or public diplomacy.
                </p>
              </div>
            </div>
            <div className="d-flex align-items-start mb-4">
              <img
                src={Picture5}
                alt="Service 2 Icon"
                style={{ width: "32px", marginRight: "12px", marginTop: "2px" }}
              />
              <div>
                <h5>Corporate & Executive Positioning</h5>
                <p>
                  360° strategy for brands, boards, and high-profile figures
                  seeking market dominance and stakeholder trust.
                </p>
              </div>
            </div>
            <div className="d-flex align-items-start">
              <img
                src={Picture6}
                alt="Service 3 Icon"
                style={{ width: "32px", marginRight: "12px", marginTop: "2px" }}
              />
              <div>
                <h5>Geopolitical & Crisis Navigation</h5>
                <p>
                  High-stakes counsel in volatile contexts to manage narratives
                  and pre-empt reputational threats.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Let’s Build Your Legacy */}
      <Container
        id="legacy"
        className="py-5 mb-4 mt-4 align-content-center bg-dark text-light"
        style={{ minHeight: "50vh" }}
        data-aos="fade-up"
      >
        <Row>
          <Col
            md={4}
            className="text-warning pb-5 align-content-center text-center"
          >
            <img
              src={Picture1}
              alt="Section Icon"
              style={{ height: "48px", marginBottom: "10px" }}
            />

            <h3 style={{ color: "rgba(211, 186, 104, 1)" }}>
              Let's Build Your Legacy
            </h3>
          </Col>
          <Col md={8}>
            <p>
              Custom engagements are tailored with confidentiality, cultural
              fluency, and measurable KPIs. Let’s discuss how Blacksmith can
              serve your vision.
            </p>
            <ul>
              <li>Complimentary 30-min strategic alignment session</li>
              <li>Global availability across time zones</li>
              <li>Direct access to founder-led advisory</li>
            </ul>
          </Col>
        </Row>
      </Container>

      {/* Get In Touch */}
      <Container id="contact" className="py-5" data-aos="fade-up">
        <h3 className="text-center text-warning mb-4">Get In Touch</h3>
        <Form onSubmit={sendEmail} ref={formRef}>
          <Row className="mb-3">
            <Col md>
              <Form.Group controlId="formName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  type="text"
                  name="from_name" // 👈 updated
                  placeholder="Enter your full name"
                  required
                />
              </Form.Group>
            </Col>
            <Col md>
              <Form.Group controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="from_email" // 👈 updated
                  placeholder="Enter your email"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="formOrganization">
            <Form.Label>Organization</Form.Label>
            <Form.Control
              type="text"
              name="organization" // 👈 updated
              placeholder="Optional"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formMessage">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="message" // 👈 updated
              placeholder="How can we help you?"
              required
            />
          </Form.Group>
          <div className="text-center">
            <Button variant="warning" type="submit">
              Submit Inquiry
            </Button>
          </div>
        </Form>
      </Container>

      {/* Thank You Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#000", borderBottom: "1px solid #555" }}
        >
          <Modal.Title className="text-warning">Thank You</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#111", color: "#fff" }}>
          <p>Your message has been sent. We will get back to you shortly.</p>
        </Modal.Body>
        <Modal.Footer
          style={{ backgroundColor: "#000", borderTop: "1px solid #555" }}
        >
          <Button variant="warning" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Footer */}
      <footer
        className="text-center py-4 text-secondary"
        style={{ backgroundColor: "#000" }}
      >
        <small>Forging Influence. Shaping Legacy.</small>
        <br />
        <small>
          &copy; {new Date().getFullYear()} The Blacksmith. All rights reserved.
        </small>
      </footer>
    </div>
  );
}

export default BlacksmithLandingPage;
